import React from "react";
import styles from "./MagazineArticle.module.scss";
import ArrowRight from "../../public/assets/icons/arrowRight.svg";

const MagazineArticle = ({ isFirst, title, desc, link, imgSrc }) => {
  return isFirst ? (
    <div className={`${styles.article} ${styles.firstArticle}`}>
      <div>
        <div className={styles.firstArticleTitle}>{title}</div>
        <div
          className={styles.firstArticleDesc}
          dangerouslySetInnerHTML={{ __html: desc }}
        />
        <a
          className={styles.firstArticleLink}
          href={link?.url}
          target={link?.target}
        >
          <div>{link?.title}</div>
          
        </a>
      </div>
    </div>
  ) : (
    <div className={`${styles.article} ${styles.commonArticle}`}>
      <div className={styles.articleContent}>
        <a
          className={styles.articleImageContainer}
          href={link?.url}
          target={link?.target}
        >
          <img src={imgSrc} alt="Article Image" />
        </a>
        <a
          href={link?.url}
          target={link?.target}
          className={styles.articleTitle}
          dangerouslySetInnerHTML={{__html: title}}
        >
          {/* {desc.split(" ").length <= 11
            ? desc
            : desc.split(" ").splice(0, 11).join(" ") + "..."} */}
          
        </a>
        <a
          className={styles.articleContentContainer}
          href={link?.url}
          target={link?.target}
        >
          <div>
            {desc.split(" ").length <= 30
              ? desc
              : desc.split(" ").splice(0, 30).join(" ") + "..."}
          </div>
        </a>
      </div>
      <a
        className={styles.articleReadMoreLink}
        href={link?.url}
        target={link?.target}
      >
        <span>{link?.title}</span>
        
      </a>
    </div>
  );
};

export default MagazineArticle;
